import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { MatFormField, MatInput } from '@angular/material/input';

import { LoaderComponent } from '@lib/shared-ui/layout/loader/loader.component';

const NOTE_MAX_LENGTH = 5000;

@Component({
  selector: 'prescriptions-appointment-notes-form',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormField, MatInput, LoaderComponent],
  templateUrl: './appointment-notes-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppointmentNotesFormComponent {
  originalContent = input<string>('');
  loading = input<boolean>(false);

  readonly isChanged = signal(false);

  protected readonly notesFc = new FormControl<string>('', [Validators.maxLength(NOTE_MAX_LENGTH)]);

  get currentValue(): string {
    return this.notesFc.value;
  }

  get isValid(): boolean {
    return this.notesFc.valid;
  }

  constructor() {
    const destroyRef = inject(DestroyRef);

    effect(() => {
      const content = this.originalContent();
      this.notesFc.setValue(content, { emitEvent: false });
      this.isChanged.set(false);
    });

    this.notesFc.valueChanges
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe(value => {
        this.isChanged.set(value !== this.originalContent());
      });
  }

  reset(): void {
    this.notesFc.setValue(this.originalContent(), { emitEvent: false });
    this.isChanged.set(false);
  }
}
